import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TableUiService} from '../../../../../components/graph-schema/table-ui.service';
import {ConfiguratorStructureService, TableLiteDto} from '@tj/tj-dmp-lib-api';
import {SelectItem} from 'primeng/api';

@Component({
    selector: 'dmp-table-list-hierarchy',
    templateUrl: './table-list-hierarchy.component.html',
    styleUrls: ['./table-list-hierarchy.component.scss'],
    standalone: false
})
export class TableListHierarchyComponent implements OnInit, OnChanges {

    items: SelectItem[];
    item: Array<string>;
    tables: TableLiteDto[];
    @Input() disabled = false;
    @Input() tenant: string;
    @Input() value: Array<string>;
    @Output() valueChange = new EventEmitter<Array<string>>();
    @Input() skipPersonalTable = false;
    @Output() skipPersonalTableChange = new EventEmitter<boolean>();

    constructor(
        protected tableUiService: TableUiService,
        protected structureResourceService: ConfiguratorStructureService
    ) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tenant || changes.skipPersonalTable) {
            this.updateList();
        }
        if (changes.value) {
            this.updateValue();
        }
    }

    updateSkipPersonalTable() {
        this.updateList();
        this.skipPersonalTableChange.emit(this.skipPersonalTable);
    }

    private updateList() {
        const filterTable = ['personal_affi_auth', 'personal_newsletter', 'campaign'];
        let passengerTable: string = null;
        if (this.tenant) {
            this.structureResourceService.getAllTablesUsingGET(this.tenant).subscribe(tables => {
                this.tables = tables.filter(t => this.filter(filterTable, t.code));
                this.tables.forEach(t => {
                    t.tableDependencies = t.tableDependencies.filter(td => this.filter(filterTable, td.table));
                    if (t.code === 'passenger' && t.label) {
                        passengerTable = t.label;
                    } else if (t.code === 'passenger' && !t.label) {
                        passengerTable = t.code;
                    }
                });
                this.items = this.tableUiService.getSelectItemListTables(this.tables);
                this.items.forEach(item => {
                    if (item.value?.includes('command') && !item.value?.includes('passenger')) {
                        item.label = item.label.concat(' (avec la table ' + passengerTable + ')');
                        item.value.push('passenger');
                    }
                });
                this.updateValue();
            });
        }
    }

    private filter(filterTable: Array<string>, code: string): boolean {
        let filter = !filterTable.includes(code);
        if (filter && this.skipPersonalTable) {
            filter = !code.startsWith('personal');
        }
        return filter;
    }

    private updateValue() {
        if (this.items) {
            if (this.value) {
                const valueName = this.value.join('');
                this.items.forEach(item => {
                    const itemName = item.value == null ? '' : item.value.join('');
                    if (valueName === itemName) {
                        this.item = item.value;
                    }
                });
            } else {
                this.item = this.items[0].value;
            }
        }
    }

    onChange() {
        this.valueChange.emit(this.item);
    }

}
